<template>
    <div class="general-top-bar">
        <div class="top-bar-image">
            <img :src="imageSrc" alt="Top Bar Icon">
        </div>
        <div class="page-title">
            {{ title }}
        </div>
    </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    imageSrc () {
      if (this.$route.path.includes('/dispatch')) {
        return '../../../../static/img/icons/dispatch.png'
      }
      if (this.title === 'Dashboard') {
        return '../../../../static/img/icons/icon-topBar-dashboard.png'
      } else if (this.title === 'Categories' ||
          this.title === 'Top Category' ||
          this.title === 'Product Options' ||
          this.title === 'Group Options' ||
          this.title === 'Product Filters' ||
          this.title === 'Product Filters' ||
          this.title === 'Custom Pages' ||
          this.title === 'Menu Links' ||
          this.title === 'Info Pages') {
        return '../../../../static/img/icons/icon-topBar-paper.png'
      } else if (this.title === 'Customers') {
        return '../../../../static/img/icons/icon-topBar-customers.png'
      } else if (this.title === 'Catalog') {
        return '../../../../static/img/icons/icon-topBar-paper.png'
      } else if (this.$route.path.includes('/marketing')) {
        return '../../../../static/img/icons/icon-topBar-marketing.png'
      } else if (this.$route.path.includes('/reports')) {
        return '../../../../static/img/icons/icon-topBar-reports.png'
      } else if (this.$route.path.includes('/feedback')) {
        return '../../../../static/img/icons/icon-topBar-feedback.png'
      } else {
        return '../../../../static/img/icons/icon-topBar-settings.png'
      }
    }
  }
}
</script>
  


// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/generalTopBar.vue